import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';

const IncompleteResponsesCounter = ({ count, ...rest }) => {
  // Formatea el número con separadores de miles
  const formattedCount =
    count !== null ? new Intl.NumberFormat('en-US').format(count) : null;

  return (
    <Card {...rest} className="h-100">
      <FalconCardHeader
        title="Encuestas Incompletas"
        light={false}
        titleTag="h5"
        className="pb-0"
      />
      <Card.Body className="pt-2">
        {count === null ? (
          <div className="text-center py-3 text-muted">
            Selecciona una encuesta para ver los datos.
          </div>
        ) : (
          <Row className="g-0 h-100 align-items-center justify-content-center">
            <Col xs="auto" className="text-center">
              <div
                className="fs-4 fw-bold font-sans-serif text-primary mb-1 lh-1 text-truncate"
                style={{
                  maxWidth: '100%', // Limita el ancho máximo al contenedor
                  overflow: 'hidden', // Oculta el desbordamiento
                  whiteSpace: 'nowrap' // Evita que el texto se divida en varias líneas
                }}
              >
                {formattedCount}
              </div>
              <div className="fs-8 text-800">Incompletas</div>{' '}
              {/* Texto más legible */}
            </Col>
          </Row>
        )}
      </Card.Body>
    </Card>
  );
};

IncompleteResponsesCounter.propTypes = {
  count: PropTypes.number, // Conteo de respuestas incompletas (puede ser null)
  className: PropTypes.string
};

IncompleteResponsesCounter.defaultProps = {
  count: null // Valor predeterminado para count
};

export default IncompleteResponsesCounter;
